// extracted by mini-css-extract-plugin
module.exports = {"container":"e_hA","pending":"e_iA","slider":"e_jA","imageContainer":"e_kA","image":"e_lA","button":"e_mA","prevButton":"e_nA","nextButton":"e_oA","disabled":"e_pA"};